export default "__VITE_ASSET__DJdeqqhm__"